import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { updateCurrentAnswers } from "src/utils/redux/slices/currentAnswers";
import { getPageSetSurvey } from "./util";
import { ActionHandlerParams } from "..";
import { getURLParams } from "src/utils/urlParams";
import {
  getFacadeFromFeatureParam,
  getMedicationFormatForFacade,
} from "src/utils/medMembershipOrder";

const questionId = "medicationFormat";

/**
 * Pre-answers `medicationFormat` for users who came in on a med facade
 * (`?feature=wegovyPen`, etc.), so their format matches the facade. Intended
 * for `onSkip` on the medicationFormat page, which is hidden for these users.
 */
export const setMedicationFormatFromFacade = ({
  store,
  pageSet,
  page,
}: ActionHandlerParams): void => {
  const facade = getFacadeFromFeatureParam(getURLParams().feature);
  const format = facade && getMedicationFormatForFacade(facade);
  if (!format) {
    return;
  }

  const survey = getPageSetSurvey(pageSet, page);
  const answers = { [questionId]: [format] as [typeof format] };

  store.dispatch(addSurveyAnswers(answers));
  store.dispatch(
    updateCurrentAnswers({
      namespace: survey.surveyNameSpace,
      answers,
    })
  );
};
